import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const auth = localStorage.getItem('tykoon_access');
    if (!auth) {
       return <Navigate to={'/signin'} />
    }
    return children;
}

export default PrivateRoute